import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { LoadingScreen } from "src/CommonComponents/LoadingScreen/index";
import { useFetch } from "src/hooks/useFetch";
import { useStation } from "src/hooks/UseStation";
import { useMessage } from "src/hooks/UseMessage";
import { useDD } from "src/hooks/UseDD";
import { useUser } from "src/hooks/useUser";
import {
  driverPinArray,
  carrierArray,
  vehicleArray,
  trailerArray,
  leftPanelArray,
} from "./Fields";
import { FieldsReducer } from "src/CommonComponents/Reducer/Index";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import MessageLog from "src/CommonComponents/Messages/MessageLog";
import { GetFullURL } from "src/CommonComponents/GlobalConfFiles/URLs";
import { useParams } from "react-router-dom";
import { ValidateConfirmChecking, ValidateDriverPIN } from "./ValidateShipDoc";
import ListModal from "src/CommonComponents/Modal/DropDownModal/DropDownListMUI";
import Card from "src/CommonComponents/Card";
function CheckinV7(props) {
  //This is a simple checkin, no service interaction just take driver data and save it, it used for Glendale, this done using a guided procedure
  const params = useParams();
  const navigate = useNavigate();
  const shipDocid = params.shipDoc;
  const fieldOperationId = "CHECKIN";
  const [continueChecking, setContinueChecking] = useState(false);
  const [showPartnerList, setShowPartnerList] = useState(false);
  const [filteredPartnerList, setfilteredPartnerList] = useState([]);
  const [keyboardFocusField, setKeyboardFocusField] = useState(null);
  const [checkinFinished, setCheckinFinished] = useState(false);
  const [terminalSetupCarrier, setTerminalSetupCarrier] = useState([]);
  const [terminalSetupShiptos, setTerminalSetupShiptos] = useState([]);
  const [stage, setStage] = useState("");
  const shipDocPrintOptions = useRef("");
  const errorOccured = useRef(false);

  const [
    _getPartnerList,
    _partnerList,
    _setParnerList,
    _errorPartnerList,
    _setErrorPartnerList,
    ,
    ,
    _loadingPartnerList,
  ] = useFetch(GetFullURL("GetPartnerPerPINandType"), { method: "POST" });

  const [
    _saveShipDoc,
    ,
    ,
    _errorSaveShipDoc,
    _setErrorSaveShipDoc,
    _successSaveShipDoc,
    _setSuccessSaveShipDoc,
    _loadingSaveShipDoc,
  ] = useFetch(GetFullURL("SaveShippingDoc"), { method: "POST" }, true);

  const [
    _getShipDoc,
    _shipDocData,
    _setShipDocData,
    _errorShipDoc,
    _setErrorShipDoc,
    ,
    ,
    _loadingShipDoc,
  ] = useFetch(GetFullURL("GetShippingDoc"), { method: "POST" }, true);

  const [
    _deterSetup,
    _deterSetupData,
    ,
    _errorDeterSetup,
    _setErrorDeterSetup,
    ,
    ,
    _loadingSetupDeter,
  ] = useFetch(GetFullURL("DetermineSetup"), { method: "POST" }, true);

  const [
    _searchWIPShipDocs,
    _serachWIPShipDocData,
    ,
    ,
    ,
    ,
    ,
    _loadingSearchWIPShipDoc,
  ] = useFetch(GetFullURL("AdvancedShipDocSearch"), { method: "POST" });
  const [
    _stationInfo,
    _getTerminalSetup,
    _terminalSetup,
    _getStationOperation,
    _stationOperation,
    _stationMessages,
    _setStationMessages,
  ] = useStation();

  const [_dd] = useDD();
  const [_user] = useUser();

  const [
    _createErrorMessage,
    _errorMessages,
    _setErorMessages,
    ,
    ,
    ,
    _createSuccessMessage,
    _successMessages,
    _setSuccessMessages,
  ] = useMessage();

  useEffect(() => {
    //This is done to get the shipDoc print options
    //this setting can come from location or terminal setup determination
    //preference is given to terminal setup, there are 4 options
    // NoPriting = 1,
    // AlwaysFromTload = 2,
    // FromTloadWhenERPDown = 3,
    //  AlwaysFromERP =4,

    if (typeof _shipDocData === "undefined") {
      return;
    }

    if (typeof _deterSetupData === "undefined") {
      return;
    }

    let locations = _shipDocData?.locationsInfoComm ?? [];

    let location = locations.find((x) => x.id == _shipDocData.locationId);

    let locationPrintOption = location?.shipDocPrintOptions;
    let termSetupPrintOption = _deterSetupData?.shipDocPrintOptions;

    if (termSetupPrintOption) {
      shipDocPrintOptions.current = termSetupPrintOption;
    } else {
      shipDocPrintOptions.current = locationPrintOption;
    }
  }, [_deterSetupData, _shipDocData]);

  useEffect(() => {
    _getShipDoc({ data: { Id: shipDocid } }, ({ data: shipDocData }) => {
      //Set the stage

      if (
        shipDocData.pin &&
        shipDocData.carrierId &&
        shipDocData.trailerId &&
        shipDocData.vehicleId
      ) {
        setStage(5);
      } else {
        setStage(1);
      }

      //If any of checking data has populated then show them
      _getStationOperation(fieldOperationId, shipDocData.fieldProcessId);
      // if (shipDocData.pin) {
      //   setContinueChecking(true);
      // }
      _deterSetup({
        data: {
          LocationId: shipDocData.locationId,
          FieldProcessId: shipDocData.fieldProcessId,
          TransportationModeId: shipDocData.transportationModeId,
          MaterialId: shipDocData.shippingDocItemsComm[0].materialId,
        },
      });
    });
  }, []);

  const onChange = (e) => {
    const {
      target: { value, name },
    } = e;
    let newValue;
    switch (e.target.type) {
      case "number":
        newValue = Number(value);
        break;
      default:
        newValue = value;
        break;
    }
    if (
      newValue === "select" ||
      newValue === "Select" ||
      newValue === "SELECT"
    ) {
      newValue = "";
    }

    const newValueObject = { [name]: newValue };
    _setShipDocData((prevState) => {
      return { ...prevState, ...newValueObject };
    });
  };

  useEffect(() => {
    if (!checkinFinished) {
      return;
    }

    let nextUrlattribute1 = "";
    let nextUrlattribute2 = "";
    let nextUrlattribute3 = "";

    if (_stationOperation.nextUrlAttribute1) {
      try {
        nextUrlattribute1 = eval(_stationOperation.nextUrlAttribute1);
      } catch (error) {
        nextUrlattribute1 = _stationOperation.nextUrlAttribute1;
      }
    }

    if (_stationOperation.nextUrlAttribute2) {
      try {
        nextUrlattribute2 = eval(_stationOperation.nextUrlAttribute2);
      } catch (error) {
        nextUrlattribute2 = _stationOperation.nextUrlAttribute2;
      }
    }

    if (_stationOperation.nextUrlAttribute3) {
      try {
        nextUrlattribute3 = eval(_stationOperation.nextUrlAttribute3);
      } catch (error) {
        nextUrlattribute3 = _stationOperation.nextUrlAttribute3;
      }
    }
    //removed delay 7/15/22 KT
    // _createSuccessMessage("94");
    // var leaveTimer = setTimeout(() => {
    //   navigate(
    //     `${_stationOperation.nextUrl}/${nextUrlattribute1}/${nextUrlattribute2}/${nextUrlattribute3}`
    //   );
    // }, 3000);
    // return () => {
    //   clearTimeout(leaveTimer);
    // };

    navigate(
      `${_stationOperation.nextUrl}/${nextUrlattribute1}/${nextUrlattribute2}/${nextUrlattribute3}`,
    );
  }, [checkinFinished]);

  useEffect(() => {
    //Get shipto and carrier dropdown from terminal setup
    if (!_deterSetupData.setupData?.orderPartnersComm) {
      return;
    }

    _deterSetupData.setupData.partnersInfoComm.forEach((element) => {
      switch (element.partnerTypeId) {
        case "SHIPTO":
          let shiptoDD = {
            value: element.id,
            label: element.partnerDescriptor,
          };
          setTerminalSetupShiptos((current) => {
            return [...current, shiptoDD];
          });
          break;
        case "CARRIER":
          let carrierDD = {
            value: element.id,
            label: element.partnerDescriptor,
          };

          setTerminalSetupCarrier((current) => {
            return [...current, carrierDD];
          });

          break;
        default:
        // code block
      }
    });
  }, [_deterSetupData]);

  const fieldsState = {
    dropDowns: _dd.shipDoc,
    trmCarriers: terminalSetupCarrier,
  };
  const handleOnKeyboardFocus = (fieldId, event) => {
    //when a keyboard field is clicked, set it in the state becuase we need
    //to only render this field
    if (event === "onFocus") {
      setKeyboardFocusField(fieldId);
    } else {
      //The blur event is triggered not only when a field is unfocused but also when a
      //field is focused it tiggers blur for all other fields, we only need to blur only
      //the relvant field in being unfocused
      if (fieldId === keyboardFocusField) {
        setKeyboardFocusField("");
      }
    }
  };

  const mergedFieldData = (field) => {
    let newFieldObject = {
      ...field,
      dataSource: _shipDocData,
      onChange,
      handleOnKeyboardFocus,
      hideKeyboard: _user.disableKeyboard,
    };

    return newFieldObject;
  };
  const leftPanelFields = leftPanelArray(fieldsState);
  const driverFields = driverPinArray(fieldsState);
  const carrierFields = carrierArray(fieldsState);
  const vehicleFields = vehicleArray(fieldsState);
  const trailerFields = trailerArray(fieldsState);

  const operationLoading =
    _loadingSaveShipDoc ||
    _loadingPartnerList ||
    _loadingShipDoc ||
    _loadingSetupDeter;

  function clearMessages(e) {
    e.stopPropagation();
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        _setSuccessSaveShipDoc([]);
        _setSuccessMessages([]);

        break;
      case "error":
        _setErrorSaveShipDoc([]);
        _setStationMessages([]);
        _setErrorShipDoc([]);
        _setErrorPartnerList([]);
        _setErorMessages([]);

        break;
      case "warning":
        break;
      default:
        break;
    }
  }
  function confirmCheckin() {
    let validationConfirmResult = ValidateConfirmChecking(
      _shipDocData,
      _createErrorMessage,
    );

    if (!validationConfirmResult) {
      return;
    }

    if (!_stationOperation.fieldOperationId) {
      _createErrorMessage(
        "76",
        _shipDocData.fieldProcessId,
        fieldOperationId.current,
      );
      return;
    }

    if (!_stationOperation.shipDocStatusId) {
      _createErrorMessage("95", fieldOperationId.current);
      return;
    }
    var DateTimeNow = moment().format("YYYY-MM-DDTHH:mm:ss");
    //load start date/end (loadEnDT, loadStDT) is set initially at check-in and finally at signature
    let shipDataforSave = {
      ..._shipDocData,
      checkedStatus: "X",
      checkedStDT: DateTimeNow,
      checkedEnDT: DateTimeNow,
      statusId: _stationOperation.shipDocStatusId,
      shipDocDate: DateTimeNow,
      startDT: DateTimeNow,
      weightUnitId: "LB",
      terminalSetupId: _deterSetupData.trmSetupId,
      terminalActivityinProcess: _stationOperation.terminalActivityinProcess,
      shipDocPrintOptions: shipDocPrintOptions.current,
      currentStation: _stationInfo.id,
    };
    _saveShipDoc({ data: shipDataforSave }, ({ data: newShipDocData }) => {
      _setShipDocData(newShipDocData);
      setCheckinFinished(true);
      setKeyboardFocusField("");
    });
  }

  async function validatePIN() {
    _setErorMessages([]);
    let pinValidationResult = ValidateDriverPIN(
      _shipDocData,
      _createErrorMessage,
    );
    if (!pinValidationResult) {
      return;
    }
    //When pressing the validate pin, clear the driver info
    _setShipDocData((current) => {
      return {
        ...current,
        driverDescriptor: "",
        driverId: "",
      };
    });

    var driverList = await _getPartnerList({
      data: {
        partnerTypeId: "DRIVER",
        Pin: _shipDocData.pin,
      },
    });
    if (!Array.isArray(driverList)) {
      _createErrorMessage("18");
      errorOccured.current = true;
      return;
    }
    if (driverList.length === 0 || driverList == undefined) {
      _createErrorMessage("18");
      errorOccured.current = true;
      return;
    }
    let locationDriverList = [];
    locationDriverList = driverList.filter(
      (x) => x.locationId === _stationInfo.locationId,
    );

    if (locationDriverList.length === 0) {
      _createErrorMessage("18");
    }
    if (locationDriverList.length === 1) {
      _setShipDocData((current) => {
        return {
          ...current,
          driverDescriptor: locationDriverList[0].partnerDescriptor,
          driverId: locationDriverList[0].id,
        };
      });
      //setContinueChecking(true);
      setKeyboardFocusField("");
      setStage(2);
      return;
    }
    if (locationDriverList.length > 1) {
      setfilteredPartnerList(locationDriverList);
      setShowPartnerList(true);
      return;
    }
  }

  const handelListSelect = (id) => {
    let partner = _partnerList.find((x) => x.id === id);

    if (partner) {
      _setShipDocData((current) => {
        return {
          ...current,
          driverDescriptor: partner.partnerDescriptor,
          driverId: partner.id,
        };
      });

      setStage(2);
    }
  };

  async function nextButton() {
    _setErorMessages([]);
    switch (stage) {
      case 1:
        await validatePIN();
        break;
      case 2:
        if (
          _shipDocData.carrierId == "" ||
          _shipDocData.carrierId === undefined
        ) {
          _createErrorMessage("5");
        } else {
          setStage((current) => current + 1);
        }

        break;
      case 3:
        if (
          _shipDocData.vehicleId == "" ||
          _shipDocData.vehicleId === undefined
        ) {
          _createErrorMessage("63");
        } else {
          setStage((current) => current + 1);
        }

        break;
      case 4:
        if (
          _shipDocData.trailerId == "" ||
          _shipDocData.trailerId === undefined
        ) {
          _createErrorMessage("6");
        } else {
          setStage((current) => current + 1);
        }

        break;
      case 5:
        if (
          _shipDocData.trailerId == "" ||
          _shipDocData.trailerId === undefined
        ) {
          _createErrorMessage("6");
        }
        if (
          _shipDocData.vehicleId == "" ||
          _shipDocData.vehicleId === undefined
        ) {
          _createErrorMessage("63");
        }

        await validatePIN();
        confirmCheckin();

        break;
      default:
      // code block
    }
  }

  const backButton = () => {
    if (stage > 1) {
      setStage((current) => current - 1);
    }
  };
  return (
    <div className="container-fluid">
      {operationLoading && <LoadingScreen />}
      <div className="row">
        <div className="col-lg-3 col-sm-12 col-xs-12" id="leftPanel">
          <Card
            cardHeaderProps={{
              headerLabel: "Checkin",
            }}
            cardBody={leftPanelFields.map((field, index) => (
              <FieldsReducer field={mergedFieldData(field)} key={index} />
            ))}
            style={{ width: "100%" }}
          />
        </div>
        {stage === 5 && (
          <div className="col-lg-6 col-sm-12 col-xs-12" id="rightPanel">
            <Card
              cardHeaderProps={{}}
              cardBody={driverFields.map((field, index) => (
                <FieldsReducer field={mergedFieldData(field)} key={index} />
              ))}
              style={{ width: "100%" }}
            />
            <Card
              cardHeaderProps={{}}
              cardBody={carrierFields.map((field, index) => (
                <FieldsReducer field={mergedFieldData(field)} key={index} />
              ))}
              style={{ width: "100%" }}
            />
            <Card
              cardHeaderProps={{}}
              cardBody={vehicleFields.map((field, index) => (
                <FieldsReducer field={mergedFieldData(field)} key={index} />
              ))}
              style={{ width: "100%" }}
            />
            <Card
              cardHeaderProps={{}}
              cardBody={trailerFields.map((field, index) => (
                <FieldsReducer field={mergedFieldData(field)} key={index} />
              ))}
              style={{ width: "100%" }}
            />
          </div>
        )}
        {stage === 1 && (
          <div className="col-lg-6 col-sm-12 col-xs-12" id="rightPanel">
            <Card
              cardHeaderProps={{}}
              cardBody={driverFields.map((field, index) => (
                <FieldsReducer field={mergedFieldData(field)} key={index} />
              ))}
              style={{ width: "100%" }}
            />
          </div>
        )}
        {stage === 2 && (
          <div className="col-lg-6 col-sm-12 col-xs-12" id="rightPanel">
            <Card
              cardHeaderProps={{}}
              cardBody={carrierFields.map((field, index) => (
                <FieldsReducer field={mergedFieldData(field)} key={index} />
              ))}
              style={{ width: "100%" }}
            />
          </div>
        )}
        {stage === 3 && (
          <div className="col-lg-6 col-sm-12 col-xs-12" id="rightPanel">
            <Card
              cardHeaderProps={{}}
              cardBody={vehicleFields.map((field, index) => (
                <FieldsReducer field={mergedFieldData(field)} key={index} />
              ))}
              style={{ width: "100%" }}
            />
          </div>
        )}
        {stage === 4 && (
          <div className="col-lg-6 col-sm-12 col-xs-12" id="rightPanel">
            <Card
              cardHeaderProps={{}}
              cardBody={trailerFields.map((field, index) => (
                <FieldsReducer field={mergedFieldData(field)} key={index} />
              ))}
              style={{ width: "100%" }}
            />
          </div>
        )}
        <div className="col-lg-3 col-sm-12 col-xs-12" id="buttons">
          <div className="row px-2">
            <Button
              className="btn btn-primary mt-1"
              style={{
                hight: "350ev",
                background: "#08bd55",
                borderColor: "#08bd55",
                fontSize: "45px",
              }}
              onClick={nextButton}
            >
              NEXT
            </Button>
          </div>
          <div className="row px-2 mt-5">
            <Button
              className="btn btn-primary mt-1"
              style={{
                hight: "350ev",
                background: "#DA1212",
                borderColor: "#DA1212",
                fontSize: "35px",
              }}
              onClick={backButton}
            >
              Back
            </Button>
          </div>
        </div>
      </div>

      <div className="row">
        <MessageLog
          errorMessages={[
            ..._errorPartnerList,
            ..._errorSaveShipDoc,
            ..._errorShipDoc,
            ..._errorMessages,
            ..._stationMessages,
          ]}
          successMessages={[..._successMessages, ..._successSaveShipDoc]}
          warningMessages={[]}
          clearMessages={clearMessages}
        ></MessageLog>
      </div>
      <ListModal
        setId={handelListSelect}
        dataList={filteredPartnerList}
        showListModal={showPartnerList}
        setShowModal={setShowPartnerList}
        title="List of Drivers"
        columns={[
          { field: "id", headerName: "Driver ID", width: 150 },
          {
            field: "name",
            headerName: "Driver Name",
            width: 250,
          },
        ]}
      />
    </div>
  );
}

export default CheckinV7;
